{
  "accountInformation": "अकाउंट जानकारी",
  "accountStatus": "अकाउंट स्थिति",
  "active": "सक्रिय",
  "admin": "एडमिन",
  "adminBadge": "एडमिन",
  "adminPrivileges": "व्यवस्थापक अधिकार",
  "aiDefaultHelp": "मैं आज आपकी कैसे मदद कर सकता हूं?",
  "aiDepositHelp": "जमा संबंधी समस्याओं, देरी या पुष्टिकरण के बारे में पूछें।",
  "aiKycHelp": "KYC सत्यापन और दस्तावेज़ आवश्यकताओं के बारे में पूछें।",
  "aiLoginHelp": "लॉगिन, पासवर्ड या खाता एक्सेस समस्याओं के बारे में पूछें।",
  "aiP2pHelp": "P2P ऑर्डर, विवाद या भुगतान समस्याओं के बारे में पूछें।",
  "aiSupportAssistant": "AI सहायता सहायक",
  "aiSupportAssistantText": "सामान्य प्रश्नों के तुरंत उत्तर पाएं, या हमारी टीम के लिए टिकट बनाएं।",
  "aiWithdrawHelp": "निकासी की स्थिति, देरी या आवश्यकताओं के बारे में पूछें।",
  "askAiSupport": "AI सहायता से पूछें",
  "bio": "पेशेवर बायो",
  "capital": "पूंजी",
  "changeImage": "छवि बदलें",
  "cnicBack": "पहचान पत्र (पीछे)",
  "cnicFront": "पहचान पत्र (सामने)",
  "connectedWallet": "कनेक्टेड वॉलेट",
  "country": "Country",
  "createSupportTicket": "सहायता टिकट बनाएं",
  "describeIssue": "अपनी समस्या का वर्णन करें",
  "disabled": "अक्षम",
  "displayName": "Display Name",
  "editProfile": "प्रोफ़ाइल संपादित करें",
  "email": "ईमेल",
  "emailOtpSendFailed": "सत्यापन कोड भेजने में विफल। कृपया पुनः प्रयास करें।",
  "emailOtpSent": "सत्यापन कोड आपके ईमेल पर भेज दिया गया है।",
  "emailVerification": "ईमेल वेरिफिकेशन",
  "emailVerifiedSuccessfully": "ईमेल सफलतापूर्वक सत्यापित हो गया।",
  "enabled": "सक्रिय",
  "enterEmailOtp": "सत्यापन कोड दर्ज करें",
  "enterOtpFirst": "कृपया पहले सत्यापन कोड दर्ज करें।",
  "estimatedProfit": "अनुमानित लाभ",
  "faceVerificationNotAutomated": "स्वचालित चेहरा सत्यापन अभी उपलब्ध नहीं है। आपकी अपलोड की गई सेल्फी की KYC अनुमोदन के भाग के रूप में मैन्युअल रूप से समीक्षा की जाएगी।",
  "failedLoadNotifications": "सूचनाएं लोड करने में विफल।",
  "failedMarkAllRead": "सभी को पढ़ा हुआ चिह्नित करने में विफल।",
  "failedMarkRead": "पढ़ा हुआ चिह्नित करने में विफल।",
  "failedSubmitTicket": "टिकट सबमिट करने में विफल।",
  "fullLegalName": "पूरा कानूनी नाम",
  "fullName": "पूरा नाम",
  "idNumber": "पहचान संख्या",
  "imagePreview": "छवि पूर्वावलोकन",
  "imageTooLarge": "अधिकतम छवि आकार 5 MB है।",
  "inactive": "निष्क्रिय",
  "invalidImageType": "केवल JPG, PNG और WEBP छवियों की अनुमति है।",
  "invalidOtp": "कोड अमान्य है या समय समाप्त हो गया है। कृपया पुनः प्रयास करें।",
  "joinedDate": "शामिल होने की तारीख",
  "kycStatus": "KYC स्थिति",
  "kycSubmissionFailed": "KYC सबमिट करना विफल रहा।",
  "kycSubmittedSuccessfully": "KYC सफलतापूर्वक सबमिट किया गया।",
  "lastLogin": "अंतिम लॉगिन",
  "liquidationZone": "परिसमापन क्षेत्र",
  "loadingNotifications": "सूचनाएं लोड हो रही हैं...",
  "loadingProfile": "प्रोफ़ाइल लोड हो रही है...",
  "markAllRead": "सभी को पढ़ा हुआ चिह्नित करें",
  "mobileNumberCountryCode": "मोबाइल नंबर (देश कोड सहित)",
  "network": "नेटवर्क",
  "noNotifications": "अभी तक कोई सूचना नहीं।",
  "noUtilityToolsFound": "कोई उपयोगिता उपकरण नहीं मिला।",
  "notSubmitted": "सबमिट नहीं किया गया",
  "notVerifiedEmail": "असत्यापित",
  "openTool": "उपकरण खोलें",
  "owner": "स्वामी",
  "ownerBadge": "स्वामी",
  "ownerControlCenter": "स्वामी नियंत्रण केंद्र",
  "passportNationalId": "पासपोर्ट / राष्ट्रीय पहचान पत्र",
  "pending": "Pending",
  "phoneNumber": "फ़ोन नंबर",
  "positionSize": "पोज़िशन आकार",
  "positionValue": "पोज़िशन मूल्य",
  "processing": "प्रोसेसिंग...",
  "profileImage": "प्रोफ़ाइल छवि",
  "profileSecurity": "प्रोफ़ाइल सुरक्षा",
  "profileSubtitle": "अपनी प्रोफ़ाइल, KYC, वॉलेट और सुरक्षा विवरण मैनेज करें।",
  "profileTitle": "प्रोफ़ाइल",
  "profileUpdateFailed": "प्रोफ़ाइल अपडेट नहीं हो सकी",
  "profileUpdatedSuccessfully": "प्रोफ़ाइल सफलतापूर्वक अपडेट हो गई",
  "read": "पढ़ा गया",
  "rejected": "Rejected",
  "removeImage": "छवि हटाएं",
  "required": "आवश्यक",
  "riskAmount": "जोखिम राशि",
  "riskPercent": "जोखिम प्रतिशत",
  "riskPositionCalculator": "जोखिम और पोज़िशन कैलकुलेटर",
  "role": "भूमिका",
  "saveProfile": "प्रोफ़ाइल सेव करें",
  "savingProfile": "प्रोफ़ाइल सहेजी जा रही है...",
  "securityLevel": "सुरक्षा स्तर",
  "selfieVerification": "सेल्फी सत्यापन",
  "sendEmailOtp": "ईमेल OTP भेजें",
  "sendingEmailOtp": "भेजा जा रहा है...",
  "serverError": "सर्वर त्रुटि।",
  "sessionActive": "सत्र सक्रिय",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "subject": "विषय",
  "submitKyc": "KYC सबमिट करें",
  "submitTicket": "टिकट सबमिट करें",
  "submittingKyc": "KYC सबमिट किया जा रहा है...",
  "supportBadge": "सहायता",
  "supportRequiredFields": "विषय और विवरण आवश्यक हैं।",
  "telegram": "टेलीग्राम",
  "ticketSubmittedSuccessfully": "टिकट सफलतापूर्वक सबमिट किया गया।",
  "tools": "उपकरण",
  "totalNotifications": "कुल सूचनाएं",
  "twoFactorStatus": "दो-कारक प्रमाणीकरण",
  "uid": "यूआईडी",
  "unread": "अपठित",
  "updateSuccessful": "प्रोफ़ाइल सफलतापूर्वक अपडेट हुई।",
  "uploadBackSide": "पिछला भाग अपलोड करें",
  "uploadDocument": "दस्तावेज़ अपलोड करें",
  "uploadFrontSide": "सामने का भाग अपलोड करें",
  "uploadIdDocument": "कृपया एक पहचान दस्तावेज़ अपलोड करें।",
  "uploadImage": "छवि अपलोड करें",
  "uploadSelfie": "सेल्फी अपलोड करें",
  "uploadSelfieRequired": "सबमिट करने से पहले कृपया एक सेल्फी अपलोड करें।",
  "user": "User",
  "userId": "यूज़र आईडी",
  "userProfile": "यूज़र प्रोफ़ाइल",
  "utilityTools": "उपयोगिता उपकरण",
  "verified": "Verified",
  "verifiedBadge": "सत्यापित",
  "verifiedEmail": "सत्यापित",
  "verifyEmailFirst": "कृपया पहले अपना ईमेल सत्यापित करें।",
  "verifyingEmailOtp": "सत्यापित किया जा रहा है...",
  "walletAddress": "वॉलेट एड्रेस",
  "walletOrderTxOptional": "वॉलेट पता, ऑर्डर ID या लेनदेन ID (वैकल्पिक)",
  "writeProfessionalBio": "अपने बारे में एक छोटा प्रोफ़ेशनल परिचय लिखें"
}